import { CheckboxIndicator } from 'lib/checkbox';
import { getRem } from 'lib/core';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledListItemCheckbox = styled(CheckboxIndicator)`
  margin-left: ${getRem(5)};
`;

const ListItemCheckbox = ({ indeterminate = false, isDisabled = false, onClick, ...other }) => (
  <StyledListItemCheckbox indeterminate={indeterminate} isDisabled={isDisabled} onClick={onClick} {...other} />
);

ListItemCheckbox.propTypes = {
  /** The current value of checkbox - checked or unchecked */
  checked: PropTypes.bool.isRequired,
  /** Changes the icon and sets checkbox indeterminate parameter state */
  indeterminate: PropTypes.bool,
  /** Disables to change the value of checkbox and shows it visually disabled */
  isDisabled: PropTypes.bool,
  /** Optional callback to be called on checkbox click */
  onClick: PropTypes.func,
};

export { ListItemCheckbox, StyledListItemCheckbox };
